import { render } from "./aiAssitant.vue?vue&type=template&id=496ba78a&scoped=true"
import script from "./aiAssitant.vue?vue&type=script&lang=js"
export * from "./aiAssitant.vue?vue&type=script&lang=js"

import "./aiAssitant.vue?vue&type=style&index=0&id=496ba78a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496ba78a"]])

export default __exports__